import axios from 'axios';
import { notifications } from '@mantine/notifications';

const DC_BASE_URL = process.env.REACT_APP_DC_API_URL || 'https://p59f36qunl.execute-api.us-east-1.amazonaws.com/dc/api';

const api = axios.create({
  baseURL: DC_BASE_URL,
  timeout: 40000,
  headers: { 'Content-Type': 'application/json' },
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    const msg = error.response?.data?.message || error.message || 'Error de conexión';
    
    notifications.show({
      title: 'Error al cargar datos',
      message: `${status ? `[${status}] ` : ''}${msg}`,
      color: 'red',
      autoClose: 5000,
    });

    return Promise.reject(error);
  }
);

export default api;
